import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './Image.css';

const defaultImage = 'https://media3.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif'

export const Image = ({ alt, src }) => {
  return <LazyLoadImage
    className='lazy'
    alt={alt}
    src={src}
    effect="blur"
    beforeLoad={() => console.log('loading') }
  />;
};




// WEBPACK FOOTER //
// ./src/components/Image/Image.js